import OBase from './OBase';

import * as Geometry from '../geometry';

export default class FlattenTree extends OBase {
  update () {
    let inputTree = this.getObjectInput('Tree');
    let output = this.outputs['Tree'].paramObject;

    let root = 0;
    let pathTree = this.getObjectInput('Path');
    if (pathTree !== null) {
      root = pathTree.branches[0][0];
    }
    output.value = FlattenTree.flatten(inputTree, root);
  }

  static flatten (inputTree, root = 0) {
    let tree = new Geometry.DataTree();
    let path = new Geometry.GHPath(root);

    for (let i = 0; i < inputTree.branches.length; i++) {
      for (let j = 0; j < inputTree.branches[i].length; j++) {
        let inputObj = inputTree.branches[i][j];
        tree.add(inputObj, path);
      }
    }

    if (tree.branches.length === 0 || (tree.branches.length > 0 && tree.branches[0].length === 0)) {
      tree.addEmpty(path);
    }

    return tree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/FlattenTree.js